import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { LANGUAGES } from './constants';
import { getLanguageFromPath } from './utils';

// The URL decides the language: /en/... is English, everything else Latvian
const lng = getLanguageFromPath(window.location.pathname);

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    lng,
    fallbackLng: LANGUAGES[0],
    supportedLngs: LANGUAGES,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export { i18n };
